import { IInActiveActions} from "../../../models/action.types";
import { Quantity, IQuantity } from "../../../../common/models/quantity.model";

  export const generateInActivecommands = (
    quantity: IQuantity,
    actions: IInActiveActions,
    t: any
  ) => {

    const items = [{
        key: "restore",
        text: t('clients.commands.restore'),
        iconProps: { iconName: "refresh" },
        name: "restore",
        onClick: actions.activate,
      },
      {
        key: "delete",
        text: t('clients.commands.delete'),
        iconProps: { iconName: "delete" },
        name: "delete",
        onClick: actions.removeCompany,
      },
    ]
    const items2 = [
      {
        key: "downloadReport",
        text: t('clients.commands.download'),
        iconProps: {iconName: "ReportDocument"},
        onClick: actions.downloadInactiveClientsReport,
      }
    ]

    if (quantity === Quantity.NONE) {
      return [
        {
          key: "add",
          text: t('clients.commands.add'),
          iconProps: { iconName: "add" },
          name: "add",
          onClick: actions.addCompany,
        },
        ...items2
      ];
    }else if(quantity === Quantity.ONE){
      return [
        {
          key: "see",
          text: t('clients.commands.see'),
          iconProps: { iconName: "textDocument" },
          name: "see",
          onClick: actions.see,
        },
        {
          key: "add",
          text: t('clients.commands.add'),
          iconProps: { iconName: "add" },
          name: "add",
          onClick: actions.addCompany,
        },
        {
          key: "edit",
          text: t('clients.commands.edit'),
          iconProps: { iconName: "edit" },
          name: "edit",
          onClick: actions.edit,
        },
        ...items,
        ...items2
      ];

    } else {
      return [
        {
          key: "add",
          text: t('clients.commands.add'),
          iconProps: { iconName: "add" },
          name: "add",
          onClick: actions.addCompany,
        },
        ...items2

      ];
    }
  };